import React from "react";
import { Routes, Route } from "react-router-dom";

import Landing from "../views/public/landing/landing";
import ResetPasswordStep1_initRecovery from "../views/public/resetPassword/resetPasswordStep1_initRecovery";
import ResetPasswordStep2_checkRecovery from "../views/public/resetPassword/resetPasswordStep2_checkRecovery";
import ResetPasswordStep3_recovery from "../views/public/resetPassword/resetPasswordStep3_recovery";
import Calculator from "../views/private/crud/applications/calculator";
import AddInfoAndConfirmApplication from "../views/private/crud/applications/addInfoAndConfirmApplication";
import Summary from "../views/private/crud/applications/summary";
import Logout from "../components/logout";
import Applications from "../views/private/crud/applications/applications";
import Beneficiaries from "../views/private/crud/beneficiaries/beneficiaries";
import BeneficiariesForm from "../views/private/crud/beneficiaries/beneficiariesForm";
import Credits from "../views/private/crud/credits/credits";

const ProtectedApp = () => {

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/resetPasswordStep1_initRecovery"
          element={<ResetPasswordStep1_initRecovery />}
        />
        <Route
          path="/resetPasswordStep2_checkRecovery"
          element={<ResetPasswordStep2_checkRecovery />}
        />
        <Route
          path="/resetPasswordStep3_recovery"
          element={<ResetPasswordStep3_recovery />}
        />
        <Route path="/calculator" element={<Calculator />} />
        <Route
          path="/addInfoAndConfirmApplication"
          element={<AddInfoAndConfirmApplication />}
        />
        <Route path="/summary" element={<Summary />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/beneficiaries" element={<Beneficiaries />} />
        <Route path="/beneficiariesForm" element={<BeneficiariesForm />} />
        <Route path="/credits" element={<Credits />} />

        <Route path="/logout" element={<Logout />} />
      </Routes>
    </>
  );
};

export default ProtectedApp;
